export const FMenu = ['Home', 'Work', 'About Us', 'Portfolio', 'Services', 'Contact Us']